export const cvQuotes = [
  {
    quote: 'Luck is what happens when preparation meets opportunity.',
    author: 'Seneca',
    reason: 'An updated CV makes you ready when new opportunities appear.',
  },
  {
    quote: 'Your CV is your silent ambassador.',
    author: 'Unknown',
    reason: 'It speaks for you before you ever enter the room.',
  },
  {
    quote: 'Success is when opportunity finds you prepared.',
    author: 'Unknown',
    reason: 'Keeping your resume current ensures you’re always ready.',
  },
  {
    quote: 'A resume is a career passport.',
    author: 'Unknown',
    reason: 'Without it stamped and up to date, you can’t travel far.',
  },
  {
    quote:
      'Your career story is always being written — don’t leave old chapters as the last word.',
    author: 'Unknown',
    reason: 'Update your CV to reflect your most recent achievements.',
  },
  {
    quote: 'Opportunities don’t wait for you to update your resume.',
    author: 'Unknown',
    reason: 'If you delay, you might miss out on a role.',
  },
  {
    quote:
      'A strong CV today can be the difference between staying stuck and moving forward tomorrow.',
    author: 'Unknown',
    reason: 'Employers want to see your most recent skills and results.',
  },
  {
    quote: 'Your CV is not history, it’s marketing.',
    author: 'Unknown',
    reason: 'It should showcase your current value, not just past experiences.',
  },
  {
    quote:
      'Don’t get caught flat-footed when someone asks for your CV — stay one step ahead.',
    author: 'Unknown',
    reason: 'Being proactive signals professionalism.',
  },
  {
    quote: 'Every project completed adds a new line to your CV’s story.',
    author: 'Unknown',
    reason: 'Small updates now save time when you really need it.',
  },
  {
    quote: 'Your CV is like a garden — neglect it and it withers.',
    author: 'Unknown',
    reason: 'Regular updates keep it fresh and attractive.',
  },
  {
    quote: 'In fast-changing industries, yesterday’s skills can look outdated.',
    author: 'Unknown',
    reason: 'An up-to-date CV shows you’re keeping pace with the market.',
  },
  {
    quote: 'An updated resume is a reminder of how far you’ve come.',
    author: 'Unknown',
    reason: 'It boosts confidence when you see your own growth.',
  },
  {
    quote: 'Networking is easier when you have your latest CV on hand.',
    author: 'Unknown',
    reason: 'Contacts may ask for it unexpectedly — be ready.',
  },
  {
    quote: 'Your CV is a personal brand statement, not a relic.',
    author: 'Unknown',
    reason: 'It should reflect who you are today, not who you were years ago.',
  },
  {
    quote: 'A polished CV makes a polished first impression.',
    author: 'Unknown',
    reason: 'First impressions count, and recruiters notice the effort.',
  },
  {
    quote: 'A CV isn’t just for job hunting — it’s for career tracking.',
    author: 'Unknown',
    reason: 'It helps you reflect, measure progress, and set goals.',
  },
  {
    quote: 'Keeping your resume current is like keeping your tools sharp.',
    author: 'Unknown',
    reason: 'You never know when you’ll need them.',
  },
  {
    quote: 'You don’t get a second chance at a first impression.',
    author: 'Will Rogers',
    reason: 'A stale CV can close doors before you even knock.',
  },
  {
    quote:
      'The best time to update your CV was yesterday, the second-best is today.',
    author: 'Unknown',
    reason: 'Don’t wait until urgency forces you to scramble.',
  },
];

/** Quotes for the dashboard Job listings / Referrals bar (typewriter effect) */
export const dashboardJobQuotes = [
  "Opportunities don't always come knocking; sometimes you have to build the door.",
  'Work with purpose and the money will follow.',
  'Every small job done well is a step toward a bigger future.',
  'The best investment you can make is in your own skills.',
  'Success often begins with the courage to apply.',
  'A job is not just income; it is a chance to grow.',
  'Persistence turns job searches into job offers.',
  'Start where you are, use what you have, earn what you can.',
  'Effort today builds income tomorrow.',
  "Don't wait for opportunity; create value.",
  'Hard work plants seeds that pay dividends.',
  'Every expert was once a beginner looking for work.',
  'Your next job could start with one brave step.',
  'Skills open doors that luck alone cannot.',
  'Income grows where effort flows.',
  'Show up, improve daily, and results will come.',
  'Small earnings can grow into big achievements.',
  'Consistency beats talent when building a career.',
  'Learning is the engine of earning.',
  'Work done with pride always pays in the end.',
  'Success is built on many ordinary workdays.',
  'Determination is the strongest currency.',
  'Turn your time into value and value into income.',
  'A strong work ethic is always in demand.',
  'Progress begins with trying.',
  'The road to success is paved with effort.',
  'Reliable people are never out of work for long.',
  "Your future income depends on today's discipline.",
  'Growth starts outside your comfort zone.',
  'The search for work builds strength of character.',
  'Money follows usefulness.',
  'Show initiative and doors will open.',
  'Work is the bridge between dreams and reality.',
  'Patience and effort build lasting success.',
  'Every application is a chance for change.',
  'Value yourself and others will too.',
  'The more you learn, the more you earn.',
  'Opportunities favor the prepared.',
  'Start small but think big.',
  'A positive attitude attracts opportunity.',
  'Your skills are tools for building a better life.',
  'Keep moving forward even when progress is slow.',
  'Honest work creates honest rewards.',
  'Discipline today brings freedom tomorrow.',
  'Effort compounds over time.',
  'Stay focused on goals, not obstacles.',
  'Your determination defines your direction.',
  'Work steadily and success will follow.',
  'Every day is another chance to improve your situation.',
  'Believe in your ability to succeed.',
];
